import React from 'react';
import { countries } from '../../utils/locationData';
import { SelectField } from './SelectField';

interface CountrySelectProps {
  value: string;
  onChange: (value: string) => void;
}

export function CountrySelect({ value, onChange }: CountrySelectProps) {
  return (
    <SelectField
      id="country"
      label="Country"
      value={value}
      onChange={onChange}
      options={countries.map(country => ({
        value: country.code,
        label: country.name
      }))}
      placeholder="Select a country"
    />
  );
}